<template>
  <div class="download-dbc-file">
      <div>
        <span class="el-icon-document"></span> 
        <span class="download-dbc-name">{{fileName}}</span>
      </div>
      <el-button v-show="file"  class="dbc-button" size="small" type="primary" @click="download(file)" >{{$t('vehicleModel.download')}}</el-button>
  </div>
</template>

<script>
import download from "downloadjs";
export default {
  name: "DownloadDBCFile",
  props:{
    file:{ type: String},
    fileName: { type:String},
    deviceModel:{type:String},
    connectionType:{type:String},
  },
  data(){
    return {}
  },
  methods: {
     download(file){
      var x=new XMLHttpRequest();
	    x.open("GET", file, true);
	    x.responseType = 'blob';
	    x.onload=(e) =>{
        download(x.response, this.fileName, "text/plain" );
      }
	    x.send();
      
    },
  },
}
</script>
<style lang="stylus" scoped>
  .download-dbc-file {
    display flex
    justify-content space-between
    align-items center
    gap 40px
    height 40px
    .download-dbc-name{
      width 300px
      margin-left 10px
    }
    .dbc-button {
      width 120px
    }
  }
</style>